import { render, staticRenderFns } from "./Pqr.vue?vue&type=template&id=70808986"
import script from "./Pqr.vue?vue&type=script&lang=js"
export * from "./Pqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports